export type StatusVisualGroup = 'placed' | 'confirmed' | 'shipped' | 'canceled' | 'unknown';

export const STATUS_GROUP_SHIPPED: StatusVisualGroup = 'shipped';

export const UNKNOWN_STATUS_CODE = '00';
export const STATUS_CODE_QUEUED = '05';
export const STATUS_CODE_REQUESTED = '10';
export const STATUS_CODE_CANCELED = '20';
export const STATUS_CODE_CONFIRMED = '30';
export const STATUS_CODE_PARTIALLY_DISPATCHED = '50';
export const STATUS_CODE_GOODS_DISPATCHED = '70';
export const STATUS_CODE_PARTIALLY_RECEIVED = '80';
export const STATUS_CODE_COMPLETED = '90';

export const STATUS_CODE_ORDER = [
    STATUS_CODE_QUEUED,
    STATUS_CODE_REQUESTED,
    STATUS_CODE_CANCELED,
    STATUS_CODE_CONFIRMED,
    STATUS_CODE_PARTIALLY_DISPATCHED,
    STATUS_CODE_GOODS_DISPATCHED,
    STATUS_CODE_PARTIALLY_RECEIVED,
    STATUS_CODE_COMPLETED,
    UNKNOWN_STATUS_CODE
];

export const getStatusVisualGroup = (code: string): StatusVisualGroup => {
    if (code === STATUS_CODE_QUEUED || code === STATUS_CODE_REQUESTED) {
        return 'placed';
    }
    if (code === STATUS_CODE_CONFIRMED) {
        return 'confirmed';
    }
    if (
        code === STATUS_CODE_PARTIALLY_DISPATCHED ||
        code === STATUS_CODE_GOODS_DISPATCHED ||
        code === STATUS_CODE_PARTIALLY_RECEIVED ||
        code === STATUS_CODE_COMPLETED
    ) {
        return 'shipped';
    }
    if (code === STATUS_CODE_CANCELED) {
        return 'canceled';
    }
    return 'unknown';
};
